import { createClient } from '@supabase/supabase-js'

// Seule la cle publique a le droit d exister ici. Toute cle privilegiee
// dans ce dossier fait echouer la CI (scripts/check-guardrails.sh).
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const configure = Boolean(url && anonKey)
export const supabase = configure ? createClient(url!, anonKey!) : null
